import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Column, Exhibit } from './styled.jsx';
import { useZoomWheel } from '#~/control/wheel/hooks.js';

/** Zoom `<Wheel>` exhibit. */
export const Wheel = (): ReactElement => {
  const [zoom, takeSample] = useZoomWheel();

  return (
    <Exhibit title='Zoom Wheel'>
      <Column className='p-0'>
        <div
          className={twMerge(
            'grid h-[250px] cursor-pointer place-items-center rounded border bg-base-100',
            zoom ? 'border-primary' : 'border-secondary'
          )}
          onWheel={takeSample}
        >
          {zoom ? (
            <div className='text-xl'>{Math.round(zoom * 100)}%</div>
          ) : (
            <div>Give your mouse wheel a spin!</div>
          )}
        </div>
      </Column>
    </Exhibit>
  );
};
